import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { API_URL } from "../../shared/constant";
import Select from "react-select";
import axios from "axios";
import Swal from "sweetalert2";
import Loader from "../../shared/loader";
import Pagination from "../../shared/pagination";

const Users = () => {
  const [partyData, setPartyData] = useState([]);
  const [roles, setRoles] = useState([]);
  const [roleType, setRoleType] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  const [partyDataOriginal, setPartyDataOriginal] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [isSearchActive, setIsSearchActive] = useState(false);
  const itemsPerPage = 30;


  const getParty = (roleId, page = 1) => {
    setLoading(true);
    axios.post(API_URL.USERS_LIST, { 
      type: roleId,
      page: page,
      limit: itemsPerPage,
    }).then(
      (res) => {
        if (res.data.status === 1) {
          setPartyData(res.data.data.data);
          setPartyDataOriginal(res.data.data.data);
          const total = res.data.data.total || 0;
          setTotalPages(Math.ceil(total / itemsPerPage));
          setTotalCount(total);
        }
        setLoading(false);
      },
      (error) => {
        setLoading(false);
        toast.error("Something went wrong..", {
          autoClose: 3000,

        });
      }
    );
  };

  const getRoles = () => {
    axios.post(API_URL.USERS_ROLES, {}).then(
      (res) => {
        if (res.data.status === 1) {
          let rls = [{
            label: 'All',
            value: 0
          }]
          res.data.data.forEach((r) => {
            rls.push({
              label: r.name,
              value: r.id
            });
          })
          setRoles(rls);
        }
        setLoading(false);
      },
      (error) => {
        setLoading(false);
        toast.error("Something went wrong..", {
          autoClose: 3000,

        });
      }
    );
  };

  const deleteUser = (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this User",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axios.post(API_URL.USERS_DELETE, { id: row.id }).then(
          (res) => {
            if (res.data.status === 1) {
              toast.success("Delete Successfully", { autoClose: 3000 });
              if (isSearchActive) {
                // If search is active, refresh search results
                handleSearchChange({ target: { value: searchValue } });
              } else {
                getParty(roleType, currentPage); // reload current page
              }
            } else {
                toast.error(res.data.data, { autoClose: 3000 });
            }
            setLoading(false);
          },
          (error) => {
            setLoading(false);
            toast.error("Something went wrong..", { autoClose: 3000 });
          }
        );
      }
    });
  };

  const approveUser = (row, status) => {
    Swal.fire({
      title: (status === 0) ? 'Are you sure to block this user?' : 'Are you sure to approve this?',
      text: "",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axios.post(API_URL.USERS_APPROVE, { user_id: row.id, status: status }).then(
          (res) => {
            if (res.data.status === 1) {
              if (isSearchActive) {
                // If search is active, refresh search results
                handleSearchChange({ target: { value: searchValue } });
              } else {
                getParty(roleType, currentPage); // reload current page
              }
            }
            toast.success(row.name + " approved Successfully", { autoClose: 3000 });
            setLoading(false);
          },
          (error) => {
            setLoading(false);
            toast.error("Something went wrong..", { autoClose: 3000 });
          }
        );
      }
    });
  };

const handleSearchChange = async (e) => {
  const value = e.target.value;
  setSearchValue(value);

  if (value.length >= 3) {
    setIsSearchActive(true);
    setCurrentPage(1);
    try {
      const res = await axios.post(API_URL.USERS_SEARCH, { text: value });

      if (Array.isArray(res.data)) {
        setPartyData(res.data);
        setTotalPages(1);
        setTotalCount(res.data.length);
      } else if (Array.isArray(res.data.data)) {
        setPartyData(res.data.data);
        setTotalPages(1);
        setTotalCount(res.data.data.length);
      }
    } catch (error) {
      toast.error("Search failed", { autoClose: 2000 });
    }
  } else {
    setIsSearchActive(false);
    setCurrentPage(1);
    // Reload data from API when clearing search
    getParty(roleType, 1);
  }
};

  useEffect(() => {
    getParty(roleType, currentPage);
    getRoles();
  }, []);

  const handlePageChange = (page) => {
    if (!isSearchActive) {
      setCurrentPage(page);
      getParty(roleType, page);
    }
  };

  return (
    <>
      <div className="row">
        <div className="col-4">
          <h1>Users <small className="me-2">({isSearchActive ? partyData.length : totalCount})</small></h1>
        </div>
        <div className="col-8">
          <div className="d-flex align-items-center  justify-content-end">
            <div className="form-group mb-0 mr-2" style={{ width: 300 }}>
              <Select
                options={roles}
                value={roles.find((r) => r.value == roleType)}
                // styles={styles}
                onChange={(e) => {
                  setRoleType(e.value);
                  setCurrentPage(1);
                  getParty(e.value, 1);
                }
                }
              />
            </div>
            <div className="col-md-5 mb-0 mr-2">
              <div className="form-group mb-0 mr-2">
                <input
                  type="text"
                  value={searchValue}
                  onChange={handleSearchChange}
                  className="form-control"
                  placeholder="Search by Name ..."
                />

              </div>
            </div>
            <Link to={"/users/add"} className="btn btn-primary">
              <i className="fa fa-plus-circle me-2" aria-hidden="true"></i> Add User
            </Link>
          </div>
        </div>
        <div className="col-sm-12">
          <div className="card">
            <div className="card-body p-0">
              {loading && <Loader></Loader>}
              {!loading && (
                <div>
                  <div className="table-responsive">
                    <table className="table">
                      <thead className="">
                        <tr>
                          <th>#</th>
                          <th>Name</th>
                          <th>Email</th>
                          <th>Contact</th>
                          <th>Location</th>
                          <th
                            className="text-center"
                            style={{ width: "200px" }}
                          >
                            Actions
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {partyData.map((row, key) => {
                          return (
                            <tr key={key}>
                              <td style={{ maxWidth: 30 }}>{isSearchActive ? key + 1 : (currentPage - 1) * itemsPerPage + key + 1}</td>
                              <td style={{ maxWidth: 100 }}>{row.name}</td>
                              <td style={{ maxWidth: 100 }}>{row.email}</td>
                              <td style={{ maxWidth: 70 }}>{row.contact_no}</td>
                              <td style={{ maxWidth: 100 }}>{row.city_name}, {row.state_name}</td>
                              <td className="d-flex justify-content-center gap-2" style={{ width: "250px" }}>
                                <Link to={"/users/edit/" + row.id} className="btn btn-sm btn-secondary mr-2">
                                  <i className="fa fa-edit me-1"></i> Edit
                                </Link>
                                {row.status === 0 ? <button onClick={() => approveUser(row, 1)} className="btn btn-sm btn-success mr-2">
                                  <i className="fa fa-check me-1"></i> Approve
                                </button> :
                                  <button onClick={() => approveUser(row, 0)} className="btn btn-sm btn-danger mr-2">
                                    <i className="fa fa-trash me-1"></i> Block
                                  </button>}
                                <button onClick={() => deleteUser(row)} className="btn btn-sm btn-danger">
                                  <i className="fa fa-trash me-1"></i> Delete
                                </button>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                  {!isSearchActive && totalPages > 1 && (
                    <div className="d-flex justify-content-center my-3">
                      <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={handlePageChange}
                      />
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Users;
